import { BlockAdsRelatedProps } from '../../components/blocks/BlockAdsRelated'
import { AdsCardVariant } from '../../components/AdsCard/styled'
import { Classified } from '../../rest/types/Classified'
import { classifiedCardTransformer } from '../../rest/transformers/classifiedTransformer'

export function adsRelatedTransformer({
  classifiedsByCategoryResponse,
  t,
}: {
  classifiedsByCategoryResponse: Array<Classified>
  t: any
}): BlockAdsRelatedProps | undefined {
  return classifiedsByCategoryResponse
    ? {
        title: t('block_ads_related_title'),
        items: classifiedsByCategoryResponse?.map((item) =>
          classifiedCardTransformer({
            data: item,
            t,
            colorVariant: AdsCardVariant.secondary,
          })
        ),
      }
    : undefined
}
